module.exports = __webpack_public_path__ + "img/Emblem2.63e6c928.png";